export default {"src":"/_next/static/media/dark.446ac752.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};